import { Routes, Route } from "react-router-dom";
import AddDoctor from "./AddDoctor";
import Appointment from "./Appointment";
import Dashboard from "./Dashboard";
import Doctors from "./Doctors";
import EditDoctor from "./EditDoctor";
import SignIn from "./SignIn";
import PrivateRoute from "./Private";
import SelectApp from "./SelectApp";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/doctors"
          element={
            <PrivateRoute>
              <Doctors />
            </PrivateRoute>
          }
        />
        <Route
          path="/doctors/:docId"
          element={
            <PrivateRoute>
              <EditDoctor />
            </PrivateRoute>
          }
        />
        <Route
          path="/doctors/new"
          element={
            <PrivateRoute>
              <AddDoctor />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<SignIn />} />
        <Route path="/:serviceType" element={<Appointment />} />
        <Route path="/" element={<SelectApp />} />
      </Routes>
    </div>
  );
}

export default App;
